<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn
            color="primary"
            align="right"
            @click="openDialog"
        >
          Thêm banner
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="banners"
            :items-per-page="10"
            class="elevation-1"
        >
          <template v-slot:item.photo_url_path="{ item }" >
            <v-img width="80px" contain  :src="item && item.photo_url_path ? item.photo_url_path: require('@/assets/images/bi_image.png')"></v-img>
          </template>
          <template v-slot:item.photo_url_mobile_path="{ item }" >
            <v-img width="80px" contain :src="item.photo_url_mobile_path ? item.photo_url_mobile_path : require('@/assets/images/bi_image.png')"></v-img>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.id)">
              mdi-pencil
            </v-icon>
            <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
            <!--                mdi-eye-->
            <!--              </v-icon>-->
            <v-icon small @click="deleteItem(item.id)">
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:item.active="{ item }">
            <div >
              <v-checkbox v-model="item.active" ></v-checkbox>
            </div>
<!--            <div v-else>-->
<!--              <v-checkbox v-model="item.active" value :disabled="disable"  @change="active(item.id)"></v-checkbox>-->
<!--            </div>-->
          </template>
        </v-data-table>
      </v-col>

<!--      dialog-->
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600"
      >
        <v-card class="rounded-lg">
          <v-card-title  class="d-flex justify-center">
            Thêm thuộc tính
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <span class="d-flex justify-center font-weight-bold">Ảnh desktop</span>
                <v-file-input
                    label="Ảnh"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="fileDesktop"
                    v-model="name_img1"
                ></v-file-input>
                <v-img
                    width="100px"
                    height="100px"
                    contain
                    :src="src1"
                ></v-img>
                <v-text-field v-if="src1"
                    background-color="#EDF2F7"
                    filled
                    label="Alt ảnh desktop"
                    v-model="alt_image"
                    placeholder="Nhập alt"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <span class="d-flex justify-center font-weight-bold">Ảnh mobile</span>
                <v-file-input
                    label="Ảnh"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="fileMobile"
                    v-model="name_img2"
                ></v-file-input>
                <v-img
                    width="100px"
                    height="100px"
                    contain
                    :src="src2"
                ></v-img>
                <v-text-field v-if="src2"
                    background-color="#EDF2F7"
                    filled
                    label="Alt ảnh mobile"
                    v-model="alt_image_mobile"
                    placeholder="Nhập alt"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="types"
                    item-text="text"
                    item-value="id"
                    v-model="type"
                    label="Chọn loại link"
                ></v-select>
              </v-col>
              <v-col cols="12" v-show="type == 1">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="list_type"
                    item-text="text"
                    item-value="id"
                    v-model="select_type"
                    label="Chọn loại"
                ></v-select>
              </v-col>
              <v-col cols="12" v-show="type == 1">
                <v-autocomplete
                    background-color="#EDF2F7"
                    filled
                    :items="list_ids"
                    item-text="name"
                    item-value="id"
                    v-model="object_id"
                    label="Chọn ID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-show="type == 2">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Đường dẫn URL"
                    v-model="url"
                    placeholder="Nhập đường dẫn"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="dialog = false"
            >
              Hủy
            </v-btn>
            <v-btn v-if="is_edit"
                color="primary"
                text
                @click="update"
            >
              Lưu
            </v-btn>
            <v-btn
                v-else
                color="primary"
                text
                @click="addNew"
            >
              Lưu
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";
import {GET_LIST_BANNER, SET_DETAIL_BANNER, UPLOAD_BANNER_IMAGE, SAVE_BANNER, GET_DETAIL_BANNER, UPDATE_BANNER, DELETE_BANNER, CHANGE_ACTIVE_BANNER} from '@/store/modules/configs';
import {GET_LIST_CATEGORY} from "@/store/modules/category";
import {GET_LIST_BRAND} from "@/store/modules/brand";
import {GET_LIST_TAG} from "@/store/modules/tag";

export default {
  data() {
    return {
      disable:false,
      name_img1:null,
      name_img2:null,
      name_type: '',
      object_id:null,
      src1:'',
      src2:'',
      alt_image:'',
      alt_image_mobile:'',
      select_type: null,
      dialog:false,
      list_ids: [],
      type: null,
      types: [
        {
          id:1,
          text: 'Link theo loại'
        },
        {
          id:2,
          text: 'Link theo URL'
        },
      ],
      list_type: [
        {
          id:1,
          text: 'category'
        },
        {
          id:2,
          text: 'brand'
        },
        {
          id:3,
          text: 'tag'
        },
      ],
      items:[
        {
          id: 1,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
        {
          id: 2,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
        {
          id: 3,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
      ],
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Ảnh desktop', value: 'photo_url_path' },
        { text: 'Ảnh mobile', value: 'photo_url_mobile_path' },
        { text: 'Actions', value: 'actions' },
        // { text: '', value: 'active' },
      ],
      url:'',
      is_edit: false,
    };
  },
  watch:{
    banners(val) {
      this.disable = false
      val.forEach((el) => {
        if(el.active == true) {
          this.disable = true
        }
      })
    },
    banner(val){
      if (val && val.type && val.id){
        this.src1 = val.photo_url_path;
        this.src2 = val.photo_url_mobile_path;
        if (val.link.type){
          this.select_type = this.list_type.find(el=> el.text == val.link.type).id
        }
        this.type = val.type
        this.object_id = parseInt(val.link.object_id);
        this.url = val.link.url;
        this.alt_image = val.alt_image ?? '';
        this.alt_image_mobile = val.alt_image_mobile ?? '';
      }
    },
    select_type(val){
      const _this = this;
      if (val == 1) {
        this.name_type = 'category';
        this.$store.dispatch(`${GET_LIST_CATEGORY}`).then((data)=>{
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == 2) {
        this.name_type = 'brand';
        this.$store.dispatch(`${GET_LIST_BRAND}`).then((data)=>{
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == 3) {
        this.name_type = 'tag';
        this.$store.dispatch(`${GET_LIST_TAG}`).then((data)=>{
          console.log(data)
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      banners: 'banners',
      banner: 'banner',
      categories: 'categories',
      brands: 'brands',
    })
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_BANNER}`);
    await this.$store.commit(`${SET_DETAIL_BANNER}`,{});
  },
  methods:{
    async addNew(){
      const _this = this;
      if (this.type == 2) {
        this.name_type = '';
        this.object_id = null;
      }
      if (this.type == 1){
        this.url='';
      }
      let data_banner = {
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        alt_image:this.alt_image,
        alt_image_mobile: this.alt_image_mobile,
        active: true,
        type: this.type,
        link: {
          type: this.name_type,
          object_id: this.object_id,
          url: this.url
        }
      }
      await this.$store.dispatch(`${SAVE_BANNER}`,data_banner).then((data)=>{
        if(data.data.status) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_LIST_BANNER}`);
          this.dialog = false;
        }else{
          alert(data.data.errors)
        }
      })
    },
    async update(){
      const _this = this;
      if (this.type == 2) {
        this.name_type = '';
        this.object_id = null;
      }
      if (this.type == 1){
        this.url='';
      }
      if (this.banner && this.banner.id) {
        let data_banner = {
          id: this.banner.id,
          photo_url: this.banner.photo_url,
          photo_url_mobile: this.banner.photo_url_mobile,
          alt_image:this.alt_image ?? '',
          alt_image_mobile: this.alt_image_mobile ?? '',
          type: this.type,
          active: this.banner.active,
          link: {
            type: this.name_type,
            object_id: this.object_id,
            url: this.url
          }
        }
        await this.$store.dispatch(`${UPDATE_BANNER}`,data_banner).then((data)=>{
          if(data.data.status) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            _this.$store.dispatch(`${GET_LIST_BANNER}`);
            this.dialog = false;
          }else{
            alert(data.data.errors)
          }
        })
      }
    },
    async openDialog() {
      this.is_edit = false;
      await this.$store.commit(`${SET_DETAIL_BANNER}`,{});
      this.src1 = '';
      this.src2 = '';
      this.select_type = null;
      this.type = null
      this.object_id = null;
      this.url = '';
      this.name_img1 = null;
      this.name_img2 = null;
      this.alt_image = '';
      this.alt_image_mobile = '';
      this.dialog = true
    },
    async editItem(id)
    {
      this.is_edit = true
      await this.$store.dispatch(`${GET_DETAIL_BANNER}`,id).then((data)=>{
        if(data) {
          this.dialog = true;
        }
      })
    },
    async deleteItem(id){
      const _this = this;
      confirm('Bạn có chắc muốn xóa?') &&
      await this.$store.dispatch(`${DELETE_BANNER}`,id).then(data=>{
        if(data && data.status === 1) {
          _this.$store.dispatch(`${GET_LIST_BANNER}`);
        }
      })
    },
    async active(id){
      this.disable = false
      this.banners.forEach((el) => {
        if(el.active == true) {
          this.disable = true
        }
      })
      const _this = this;
      await this.$store.dispatch(`${GET_DETAIL_BANNER}`,id).then((data)=>{
        if(data) {
          let data_active = {
            id: id,
            active: !data.data.active,
          }
          _this.$store.dispatch(`${CHANGE_ACTIVE_BANNER}`, data_active)
        }
      })
    },
    fileDesktop(event){
      const _this = this;
      if (!event) {
        this.src1 = '';
      }
      this.src1=URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_BANNER_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.banner.photo_url = element.path;
          })
        }
      })
    },
    fileMobile(event){
      const _this = this;
      if (!event) {
        this.src2 = '';
      }
      this.src2=URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_BANNER_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.banner.photo_url_mobile = element.path;
          })
        }
      })
    }
  }
};
</script>